import "./MatchCardStyles.css"


import React from 'react'

const MatchCard = () => {
  return (
    <div className="match">
        <h1>-MATCHES-</h1>
        <div className="card-container ">
            <div className="card">
                <h3 className="won">Match-1</h3>
                <h3>Man City v West Ham</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 2-0 Victory</p>
                <p>Erling Haaland scored a brace.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-2</h3>
                <h3>Man City v Bournemouth</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 4-0 Victory</p>
                <p>Kevin De Bruyne scored and assisted.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="draw">Match-3</h3>
                <h3>Newcastle v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 3-3 Draw</p>
                <p>Haaland, Gündoğan, Silva scored the goals.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>
            
            <div className="card">
                <h3 className="won">Match-4</h3>
                <h3>Crystal Palace v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 2-4 Victory</p>
                <p>Erling Haaland scored his firstever PL Hat-trick.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-5</h3>
                <h3>Nottingham Forest v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-6 Victory</p>
                <p>Haaland hat-trick and Alvarez brace.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="draw">Match-6</h3>
                <h3>Aston Villa v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-1 Draw</p>
                <p>Tight defensive game with an obvious Haaland goal.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-7</h3>
                <h3>Wolverhampton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-3 Vict0ry</p>
                <p>De Bruyne gives a brace of Assists.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-8</h3>
                <h3>Man United v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 3-6 Victory</p>
                <p>Haaland and Phil Foden each score a hat-trick.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-9</h3>
                <h3>Southampton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-4 Victory</p>
                <p>Foden scored and assisted once.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="lost">Match-10</h3>
                <h3>Liverpool v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-0 Loss</p>
                <p>Allison assisted all the way to Salah breaking the deadlock.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-11</h3>
                <h3>Brighton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-3 Victory</p>
                <p>Another Haaland brace.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-12</h3>
                <h3>Leicester v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-1 Victory</p>
                <p>De Bruyne scored a magnificent FreeKick.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-13</h3>
                <h3>Fulham v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-2 Victory</p>
                <p>Haaland scored a last minute Penalty to win the tight match-up.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="lost">Match-14</h3>
                <h3>Brentford v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 2-1 Loss</p>
                <p>Ivan Toney scored a last minute screamer to win.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-15</h3>
                <h3>Leeds v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-3 Victory</p>
                <p>Grealish scored a brace of assists for a brace of goals by Haaland.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>


            <div className="card">
                <h3 className="draw">Match-16</h3>
                <h3>Everton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-1 Draw</p>
                <p>Haaland scored the only goal in this defensive game.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-17</h3>
                <h3>Chelsea v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-1 Victory</p>
                <p>Riyad Mahrez scored the only goal.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="lost">Match-18</h3>
                <h3>Man United v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 2-1 Loss</p>
                <p>Rashford and Fernandes put in top performances to win the derby.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>


            {/* The easter egg in the project */}
            <div className="card golden-win">
                <h3 className="won">Match-19</h3>
                <h3>Tottenham Hotspurs v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 2-4 Victory</p>
                <p>The Best game of the league. City was 2 goal down after 1st half and then Mahrez scored a brace of a lifetime to win.
                </p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-20</h3>
                <h3>Wolverhampton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-3 Victory</p>
                <p>Another Haaland Hat-trick.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="lost">Match-21</h3>
                <h3>Tottenham Hotspurs v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-0 Loss</p>
                <p>Harry Kane scores the only goal in this reverse-fixture.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-22</h3>
                <h3>Aston Villa v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-3 Victory</p>
                <p>Riyad Mahrez assisted and scored once.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-23</h3>
                <h3>Arsenal v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-3 Victory</p>
                <p>Kevin De Bruyne MasterClass ! Scored a goal and gave an assist.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="draw">Match-24</h3>
                <h3>Nottingham Forest v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-1 Draw</p>
                <p>City dominated the game but could not get it past Navas.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-25</h3>
                <h3>Bournemouth v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-4 Victory</p>
                <p>Haaland, Foden, Alvarez scored the goals.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-26</h3>
                <h3>Newcastle v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-2 Victory</p>
                <p>This is where it really started going City's way. The defense really settled in and Stones improved ,too.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-27</h3>
                <h3>Crystal Palace v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-1 Victory</p>
                <p>Haaland scored a Penalty to win the close encounter.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-28</h3>
                <h3>Liverpool v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-4 Victory</p>
                <p>Truly a memorable match. 4 goals by 4 different goalscorers.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-29</h3>
                <h3>Southampton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-4 Victory</p>
                <p>Grealish Masterclass!</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>


            <div className="card">
                <h3 className="won">Match-30</h3>
                <h3>Leicester v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-3 Victory</p>
                <p>Another Haaland brace.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-31</h3>
                <h3>Arsenal v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-4 Victory</p>
                <p>Kevin De Bruyne Masterclass! Haaland assisted twice and scored a goal as well. </p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-32</h3>
                <h3>Fulham v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-2 Victory</p>
                <p>Alvarez and Haaland scored a goal each.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-33</h3>
                <h3>West Ham v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-3 Victory</p>
                <p>Foden,Haaland and Ake scored.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-34</h3>
                <h3>Leeds v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-2 Victory</p>
                <p>Gündoğan Masterclass! He scores the bangers when you really need them.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="won">Match-35</h3>
                <h3>Everton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-3 Victory</p>
                <p>Another Gündoğan Masterclass! He transforms into Prime R9 during title chases!</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>


            {/* The easter egg in the project */}

            <div className="card golden-win">
                <h3 className="won">Match-36</h3>
                <h3>Chelsea v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 0-1 Victory</p>
                <p>Alvarez scored the goal to confirm the Premier League title.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="draw">Match-37</h3>
                <h3>Brighton v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-1 Draw</p>
                <p>Haaland assisted Foden to score and also a banger by Enciso.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

            <div className="card">
                <h3 className="lost">Match-38</h3>
                <h3>Brentford v Man City</h3>
                <span className="bar">
                     
                </span>
                <p>Result : 1-0 Loss</p>
                <p>Pinnock Masterclass! Brentford was the only team that defeated city in both the fixtures.</p>
                {/* THIS IS THE REMINDER TO PUT A CHARTJS FILE IN HERE */}
            </div>

    


        </div>
    </div>
  )
}

export default MatchCard
